import * as Yup from 'yup';
import checkoutFormModel from './checkoutFormModel';

const {
  formField: {
    resource,
    vehicleType,
    domain,
    propertyNumber,
    firstname,
    lastname,
    document,
    areaPhone,
    phoneNumber,
    areaCellPhone,
    cellPhoneNumber,
    email,
    emailConfirmation,
    debitType,
    cardBrand,
    cardNumber,
    cardExpireFrom,
    cardExpireTo,
    cbu,
    cbuConfirmation
  }
} = checkoutFormModel;

const domainRegEx = /(^[a-z]{2}[0-9]{3}[a-z]{2}$)|(^[a-z]{3}[0-9]{3}$)|(^[a-z][0-9]{3}[a-z]{3}$)|(^[a-z][0-9]{7}$)|(^[0-9]{3}[a-z]{3}$)/i;
const cbuRegEx = /^014[0-9]{19}$/;
const documentRegEx = /^[FM]\d{7}$|^[FM]\d{6}$|^\d{7}$|^\d{8}$/;
const nameRegEx = /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s']+$/;
const todayDate = new Date()
const sixYearsAgo = todayDate.getFullYear() - 6;
const sixYearsLater = todayDate.getFullYear() + 6;
const tenYearsAgo = todayDate.getFullYear() - 10;

const validationSchema = [
  Yup.object().shape({
    [resource.name]: Yup.string().required(`${resource.requiredErrorMsg}`)
  }),
  Yup.object().shape({
    [vehicleType.name]: Yup.string().when(resource.name, {
      is: 'Rodado',
      then: Yup.string().required(`${vehicleType.requiredErrorMsg}`)
    }),
    [domain.name]: Yup.string().when(resource.name, {
      is: 'Rodado',
      then: Yup.string().required(`${domain.requiredErrorMsg}`).matches(domainRegEx, domain.invalidErrorMsg).test('checkResourceExists', domain.notFoundErrorMsg, (val) => {
        return new Promise((resolve, reject) => {
          if (val && val.length >= 6) {
            let url = new URL(`${import.meta.env.VITE_API_URL}/debit/resource`)
            url.search = new URLSearchParams({
              resource: 'Rodado',
              resourceNumber: val
            })
            fetch(url)
              .then(res => res.json())
              .then(res => resolve(res.exists))
              .catch(e => resolve(false))
          } else {
            resolve(false);
          }
        });
      })
    }),
    [propertyNumber.name]: Yup.number().when(resource.name, {
      is: 'Inmueble',
      then: Yup.number().typeError(`${propertyNumber.invalidErrorMsg}`).required(`${propertyNumber.requiredErrorMsg}`).test('checkResourceExists', propertyNumber.notFoundErrorMsg, (val) => {
        return new Promise((resolve, reject) => {
          if (val) {
            let url = new URL(`${import.meta.env.VITE_API_URL}/debit/resource`)
            url.search = new URLSearchParams({
              resource: 'Inmueble',
              resourceNumber: val
            })
            fetch(url)
              .then(res => res.json())
              .then(res => resolve(res.exists))
              .catch(e => resolve(false))
          } else {
            resolve(false);
          }
        });
      })
    }),
  }),
  Yup.object().shape({
    [firstname.name]: Yup.string()
      .required(`${firstname.requiredErrorMsg}`)
      .max(100, `${firstname.charsErrorMsg}`)
      .matches(nameRegEx, firstname.invalidErrorMsg)
      .test(
        'is-not-empty',
        `${firstname.requiredErrorMsg}`,
        (value) => value && value.trim() !== ''
      )
      .test(
        'no-only-quotes',
        `${firstname.invalidErrorMsg}`,
        (value) => !/^'+$/.test(value?.replace(/\s+/g, ''))
      ),
    [lastname.name]: Yup.string()
      .required(`${lastname.requiredErrorMsg}`)
      .max(100, `${lastname.charsErrorMsg}`)
      .matches(nameRegEx, lastname.invalidErrorMsg)
      .test(
        'is-not-empty',
        `${lastname.requiredErrorMsg}`,
        (value) => value && value.trim() !== ''
      )
      .test(
        'no-only-quotes',
        `${lastname.invalidErrorMsg}`,
        (value) => !/^'+$/.test(value?.replace(/\s+/g, ''))
      ),
    [document.name]: Yup.string().min(7, `${document.invalidErrorMsg}`).max(8, `${document.invalidErrorMsg}`).required(`${document.requiredErrorMsg}`).matches(documentRegEx, document.invalidErrorMsg),
    [areaPhone.name]: Yup.string()
      .matches(/^\d+$/, areaPhone.invalidErrorMsg)
      .when(phoneNumber.name, {
        is: (val) => val != null,
        then: Yup.string().required(areaPhone.requiredErrorMsg)
      }),
    [phoneNumber.name]: Yup.string()
      .matches(/^\d+$/, phoneNumber.invalidErrorMsg),
    [areaCellPhone.name]: Yup.string()
      .matches(/^\d+$/, areaCellPhone.invalidErrorMsg)
      .required(areaCellPhone.requiredErrorMsg),
    [cellPhoneNumber.name]: Yup.string()
      .matches(/^\d+$/, cellPhoneNumber.invalidErrorMsg)
      .required(cellPhoneNumber.requiredErrorMsg),
    [email.name]: Yup.string().email(`${email.invalidErrorMsg}`).required(`${email.requiredErrorMsg}`),
    [emailConfirmation.name]: Yup.string().oneOf([Yup.ref(email.name), null], `${emailConfirmation.invalidErrorMsg}`).required(`${emailConfirmation.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [debitType.name]: Yup.string().required(`${debitType.requiredErrorMsg}`),
    [cardBrand.name]: Yup.string().when(debitType.name, {
      is: 'Tarjeta de Credito',
      then: Yup.string().required(`${cardBrand.requiredErrorMsg}`)
    }),
    [cardNumber.name]: Yup.string().when([cardBrand.name, debitType.name], {
      is: (cardBrand, debitType) => (debitType === 'Tarjeta de Credito' && cardBrand === 'VISA'),
      then: Yup.string().required(`${cardNumber.requiredErrorMsg}`).test('checkVisa', cardNumber.invalidErrorMsg, (val) => {

        //validación de tarjeta VISA.
        if (val != null) {
          let cardNumber = val;
          // Expresión regular para verificar si el número de tarjeta Visa es válido
          var visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;
          if (visaRegex.test(cardNumber)) {
            // Eliminar espacios y guiones del número de tarjeta
            cardNumber = cardNumber.replace(/\s/g, "").replace(/-/g, "");

            var sum = 0;
            var doubleUp = false;

            // Aplicar el algoritmo de Luhn de derecha a izquierda
            for (var i = cardNumber.length - 1; i >= 0; i--) {
              var digit = parseInt(cardNumber.charAt(i), 10);

              if (doubleUp) {
                digit *= 2;
                if (digit > 9) {
                  digit -= 9;
                }
              }

              sum += digit;
              doubleUp = !doubleUp;
            }

            // La tarjeta es válida si la suma es divisible por 10
            return sum % 10 === 0;
          }

          return false;
        } else {
          return true;
        }
      })
    }).when([cardBrand.name, debitType.name], {
      is: (cardBrand, debitType) => (debitType === 'Tarjeta de Credito' && cardBrand === 'MASTERCARD'),
      then: Yup.string().required(`${cardNumber.requiredErrorMsg}`).test('checkMastercard', cardNumber.invalidErrorMsg, (val) => {

        //validación de tarjeta MASTERCARD.
        if (val != null) {
          let cardNumber = val;
          // Expresión regular para verificar si el número de tarjeta MasterCard es válido
          var mastercardRegex = /^5[1-5][0-9]{14}$/;
          if (mastercardRegex.test(cardNumber)) {
            // Eliminar espacios y guiones del número de tarjeta
            cardNumber = cardNumber.replace(/\s/g, "").replace(/-/g, "");

            var sum = 0;
            var doubleUp = false;

            // Aplicar el algoritmo de Luhn de derecha a izquierda
            for (var i = cardNumber.length - 1; i >= 0; i--) {
              var digit = parseInt(cardNumber.charAt(i), 10);

              if (doubleUp) {
                digit *= 2;
                if (digit > 9) {
                  digit -= 9;
                }
              }

              sum += digit;
              doubleUp = !doubleUp;
            }

            // La tarjeta es válida si la suma es divisible por 10
            return sum % 10 === 0;
          }

          return false;
        } else {
          return true;
        }
      })
    }),
    [cardExpireFrom.name]: Yup.date().when(debitType.name, {
      is: 'Tarjeta de Credito',
      then: Yup.date()
        .typeError(cardExpireFrom.invalidErrorMsg)
        .required(cardExpireFrom.requiredErrorMsg)
        .min(tenYearsAgo, cardExpireFrom.minErrorMsg)
        .max(new Date(), `${cardExpireFrom.invalidErrorMsg}`)
        .test(
          'is-before-cardExpireTo',
          cardExpireFrom.invalidErrorMsg,
          function (value) {
            const { [cardExpireTo.name]: cardExpireToValue } = this.parent;
            return value && cardExpireToValue ? value < cardExpireToValue : true;
          }
        ),
    }),
    [cardExpireTo.name]: Yup.date().when(debitType.name, {
      is: 'Tarjeta de Credito',
      then: Yup.date()
        .typeError(cardExpireTo.invalidErrorMsg)
        .required(cardExpireTo.requiredErrorMsg)
        .min(new Date(), `${cardExpireTo.invalidErrorMsg}`)
        .test(
          'is-after-cardExpireFrom',
          cardExpireTo.invalidErrorMsg,
          function (value) {
            const { [cardExpireFrom.name]: cardExpireFromValue } = this.parent;
            return value && cardExpireFromValue ? value > cardExpireFromValue : true;
          }
        ),
    }),
    [cbu.name]: Yup.string().when(debitType.name, {
      is: (val) => (val === 'Caja de Ahorro' || val === 'Cta Cte.'),
      then: Yup.string().required(`${cbu.requiredErrorMsg}`).matches(cbuRegEx, `${cbu.invalidErrorMsg}`).test('checkCbu', cbu.invalidErrorMsg, (val) => {

        //validación de cbu del banco provincia.
        if (val != null) {
          var block1 = val.substring(0, 7);
          var block2 = val.substring(8, 21);

          var suma1 = 0;
          for (var i = 0; i < block1.length; i++) {
            suma1 += parseInt(block1[i]) * [7, 1, 3, 9, 7, 1, 3][i];
          }

          var digitoVerificadorBloque1 = val.substring(7, 8);
          var diferencia1 = 10 - (suma1 % 10);

          if ((digitoVerificadorBloque1 != 0 && diferencia1 == digitoVerificadorBloque1) ||
            (digitoVerificadorBloque1 == 0 && diferencia1 == 10)) {

            var suma2 = 0;
            for (var j = 0; j < block2.length; j++) {
              suma2 += parseInt(block2[j]) * [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3][j];
            }

            var digitoVerificadorBloque2 = val.substring(21, 22);
            var diferencia2 = 10 - (suma2 % 10);

            if ((digitoVerificadorBloque2 != 0 && diferencia2 == digitoVerificadorBloque2) ||
              (digitoVerificadorBloque2 == 0 && diferencia2 == 10)) {
              return true;
            }
          }

          return false;
        } else {
          return true;
        }
      })
    }),
    [cbuConfirmation.name]: Yup.string().when(debitType.name, {
      is: (val) => (val === 'Caja de Ahorro' || val === 'Cta Cte.'),
      then: Yup.string().required(`${cbuConfirmation.requiredErrorMsg}`).oneOf([Yup.ref(cbu.name), null], `${cbuConfirmation.invalidErrorMsg}`)
    }),
  })
];

export default validationSchema;